/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Query Header PartialItem
 */
export type QueryHeaderPartialItem = {
    /**
     * API Response Version
     */
    _ver?: number;
    /**
     * Record Unique ID
     */
    id?: number;
    /**
     * Unix Timestamp - To Seconds Precision
     */
    created?: number;
    /**
     * Unix Timestamp - To Seconds Precision
     */
    updated?: number;
    /**
     * Customer ID
     */
    customerId?: number;
    /**
     * Customer Name
     */
    customerName?: string;
    /**
     * Unix Timestamp - To Seconds Precision
     */
    inviteTime?: number;
    /**
     * Unix Timestamp - To Seconds Precision
     */
    originalReleaseTime?: number;
    /**
     * Question Count
     */
    questionCount?: number;
    /**
     * Query Header Question Builder
     */
    questionBuilder?: string;
    /**
     * Survey Header ID
     */
    surveyId?: number;
    /**
     * Survey URL
     */
    questionUrl?: string;
    /**
     * Query Close Time if manually set by CSR - Unix Timestamp - To Seconds Precision
     */
    queryCloseTime?: number;
    /**
     * Flag for prevent expert selction automation
     */
    preventInvite?: boolean;
    /**
     * Flag for CSR Quality Review
     */
    csrReview?: boolean;
    /**
     * Flag for Test Query
     */
    isTest?: boolean;
    /**
     * Query Header Text
     */
    text?: string;
    /**
     * User ID
     */
    userId?: number;
    /**
     * Diagnosis ID
     */
    diagnosisId?: number;
    /**
     * Plan Id
     */
    planId?: number;
    /**
     * Grant Id
     */
    grantId?: number;
    /**
     * Pool Id
     */
    poolId?: number;
    /**
     * type
     */
    queryType?: QueryHeaderPartialItem.queryType;
    /**
     * Query Status
     */
    queryStatus?: QueryHeaderPartialItem.queryStatus;
    /**
     * Media Type of Query
     */
    mediaType?: QueryHeaderPartialItem.mediaType;
}

export namespace QueryHeaderPartialItem {

    /**
     * type
     */
    export enum queryType {
        ACADEMY = 'academy',
        BLINDED = 'blinded',
        EMO = 'emo',
        NORMAL = 'normal',
        VTB = 'vtb',
        PRIVATE = 'private',
        COMMUNAL = 'communal',
    }

    /**
     * Query Status
     */
    export enum queryStatus {
        OPEN = 'open',
        CLOSED = 'closed',
        ANSWERED = 'answered',
        HELD = 'held',
        PENDING_CHARGE = 'pending_charge',
        CHARGED = 'charged',
        CREATE = 'create',
        CSRHOLD = 'csrhold',
        CANCELLED = 'cancelled',
        PENDING_SURVEY = 'pending_survey',
        RELEASE = 'release',
    }

    /**
     * Media Type of Query
     */
    export enum mediaType {
        MESSENGER = 'messenger',
        AUDIO = 'audio',
        VIDEO = 'video',
    }


}
